// extracted by mini-css-extract-plugin
var _1 = "AnnotationPreview-module__animatedBackground--D5oiG";
var _2 = "AnnotationPreview-module__annotationPreview--y8lC2";
var _3 = "AnnotationPreview-module__link--KRczE";
export { _1 as "animatedBackground", _2 as "annotationPreview", _3 as "link" }
